import {Header} from 'components';
import {Container} from 'components/Layout/Container';
import i18next from 'i18next';
import React from 'react';
import {TagsPageContent} from './TagsPageContent';

function TagsPage() {
  return (
    <>
      <Header title={i18next.t('tagsPage.header')} />
      <Container className="h-full-6">
        <TagsPageContent />
      </Container>
    </>
  );
}

export default TagsPage;
